<app-modal #modal [options]="{ fullscreen: true }">
  <span slot="title">
    Wiki for
    <span *ngIf="wiki$ | async as wiki">
      {{ wiki.page.fromSnake().capitalize() }}
      <i class="bi bi-caret-right-fill"></i>
      {{ wiki.fragment.fromSnake().capitalize() }}
    </span>
  </span>

  <div class="px-4 w-100">
    <form [formGroup]="form" class="wiki-form">
      <div class="h-100" *ngIf="wiki$ | async as wiki">
        <app-quill #quillComponent [value]="wiki?.content" (quillChange)="quillChanged($event)"></app-quill>
      </div>
    </form>
  </div>

  <ng-container slot="buttons-start">
    <ng-container *ngIf="wiki$ | async as wiki">
      <form-btn class="btn btn-lg btn-white" [disabled]="!form.valid" (click)="save(wiki)">Save Changes</form-btn>
    </ng-container>
  </ng-container>
</app-modal>
